import React, { Component } from 'react';

class InputField extends Component {

  focus(){
    setTimeout(()=>{
      this._ref.focus();
    }, 300)
    
  }
  render() {
    let { input, label, type, meta: { touched, error, warning }, autoFocus, disabled, className, min, max, step, placeholder, readOnly, autoComplete } = this.props;
    return <div>
      <input ref={(i)=>this._ref = i} {...input} disabled={disabled} readOnly={readOnly} autoFocus={autoFocus} className={className} min={min} max={max} step={step} placeholder={label || placeholder} type={type} autoComplete={autoComplete} />
      {touched &&
        ((error && <span className="label label-danger">{error}</span>) ||
          (warning && <span className="label label-warning">{warning}</span>))}
    </div>
  }
}


export default InputField;


// WEBPACK FOOTER //
// app/components/InputField.jsx